import React from 'react';
import Dish from './Dish';
import Drink from './Drink';

export default function Items(props) {
    const { items } = props;

    return (
        <div className="items">
            {items.map((item, idx) => {
                return item.is_drink ?
                    <Drink drink={item} key={idx}></Drink> :
                    <Dish dish={item} key={idx}></Dish>;
            })}
        </div>
    );
}
